export default "__VITE_ASSET__PrcNJxtm__"